import React from 'react';
import FooterLink from './FooterLink';
import { FOOTER_LOCATION_GROUPS } from './utils/footerLinks';
import { useVisibleFooterSections } from './utils/useVisibleFooterSections';
import '../../assets/css/footer_locations.css';

function FooterLocationRow() {
  const groups = useVisibleFooterSections(FOOTER_LOCATION_GROUPS);

  if (!groups.length) {
    return null;
  }

  return (
    <div className='sbf-locations' data-sbf-reveal>
      {groups.map(({ key, title, links }) => (
        <div key={key} className='sbf-locations__group display-flex-column'>
          <h2 className='sbf-heading fs-13 uppercase gBold white'>{title}</h2>
          <ul className='sbf-locations__list flex-wrap'>
            {links.map((link) => (
              <li key={link.label}>
                <FooterLink link={link} />
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}

export default FooterLocationRow;
